import { Space } from 'antd';
import { AntCol } from 'components/ant/AntCol';
import { AntRow } from 'components/ant/AntRow';
import { IProvider } from 'interfaces/graphql';
import React, { FC } from 'react';

import { ContactInfo } from './ContactInfo';
import s from './Header.module.less';
import { MainInfo } from './MainInfo';
import { Rating } from './Rating';
import { StatisticsInfo } from './StatisticsInfo';

interface Props {
  provider: IProvider;
}

export const Header: FC<Props> = ({ provider }) => {
  return (
    <AntRow className={s.wrapper}>
      <AntCol xs={24} sm={4} xxl={3} className={s.mainInfoWrapper}>
        <MainInfo provider={provider} />
      </AntCol>
      <AntCol xs={24} sm={20} xxl={21} className={s.otherInfoWrapper}>
        <Space size={24}>
          <ContactInfo provider={provider} />
          <StatisticsInfo provider={provider} />
        </Space>
        <Rating rank={provider.rank} providerId={provider.id} />
      </AntCol>
    </AntRow>
  );
};
